<template>
    <div class="modal fade" :id="importModalId" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-danger">{{ title }}</h4>
                    <button type="button" class="close" aria-label="Close" @click=" closeImportModal()">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <slot></slot>
                    <div class="row">
                        <TheCustomFilePicker ref="filePicker" title="File import" :initialValue="fileUpload" error=""
                            :isReadOnly="false" :isRequire="false" :isMultiple="false"
                            @onChange="(files) => uploadFile(files)" :acceptFile="acceptFile" :key="tempKey" />
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-outline-dark pull-left"
                        @click=" closeImportModal()">&nbsp;Thoát</button>
                    <div class="pull-right">
                        <button type="button" class="btn btn-outline-info mr-1"
                            @click="downloadImportSampleFile(filename);">&nbsp;Download mẫu</button>
                        <button type="button" class="btn btn-outline-success" @click=" onImportSubmit();">&nbsp;{{
                            confirmLabelButton }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" :id="importConfirmModalId" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog custom-import-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-danger" style="text-transform:uppercase;">{{ title }} </h4>
                    <button type="button" class="close" aria-label="Close" @click="closeImportSubmit()">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="card">
                        <div class="card-body custom-table-container" style="max-height: 400px; overflow-x: auto; padding-left: 0; padding-right: 0;">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th class="sticky-action" >Dòng dữ liệu</th>
                                        <th v-for="item in columnConfig" :key="item.name">{{ item.columnTitle }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in listDataImport" :key="item.rowIndex">
                                        <td class="sticky-action" style="text-align: center; vertical-align: middle;"> 
                                                <span v-if="item.checkErrorRow" class="badge bg-danger">{{ item.rowIndex }}</span>
                                                <span v-else>{{ item.rowIndex }}</span>
                                        </td>
                                        <td style="vertical-align: middle;" v-for="(field, key) in item.data"
                                            :key="key">
                                            <span v-if="!field.isError">{{ field.value }}</span>
                                            <div v-else class="callout callout-danger" style="margin-bottom: 0;">
                                                <p v-if="field.value" style="margin-bottom: 0;">
                                                    {{ field.value }}
                                                </p>
                                                <small class="text-danger"><i class="icon fas fa-ban"></i> {{
                                                    field.error }}</small>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-outline-dark pull-left"
                        @click="closeImportSubmit()">&nbsp;Thoát</button>
                    <button v-if="!existsError" type="button" class="pull-right btn btn-outline-success"
                        @click="onSubmit();">&nbsp;Import</button>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import { ref, toRefs, watch } from "vue";
import $ from 'jquery';
import { mapActions } from 'vuex'
import TheCustomFilePicker from '@/components/shareComponents/TheCustomFilePicker.vue'
import axios from 'axios';
import objectDefaultValue from '@/config/object.env'
import { common } from '@/helper/common'
import { read, utils, writeFileXLSX } from 'xlsx'
export default {
    name: "TheImportModal",
    props: {
        title: String,
        confirmLabelButton: String,
        onClose: Function,
        onSubmit: Function,
        filename: String,
        acceptFile: String,
        showModalFlag: {
            type: Boolean,
            default: false,
        },

        columnConfig: {
            required: true,
            type: Array
        },

        dataReturn: {
            required: true,
        },

        rowBegin: {
            required: false,
            default: 1,
        },

        customsSlotCheck:{
            required: false,
            default: null,
            type: Function
        }
    },
    components: {
        TheCustomFilePicker,
    },
    data() {
        return {
            randomModalId: '_' + Math.random().toString(36).substr(2, 9),
            importModalId: '',
            importConfirmModalId: '',

            fileUpload: [],
            listDataImport: [],
            existsError: false,
            tempKey: common.randomString(10),

            isShowImportModal: false,
        }
    },
    methods: {
        ...mapActions('handleData2', ['handleTypeImport',]),

        async setup(){
            this.importModalId = 'modalImport' + this.randomModalId
            this.importConfirmModalId = 'modalConfirmImport' + this.randomModalId
        },


        async downloadImportSampleFile(filename) {
            let pathFile = objectDefaultValue.IMPORT_SAMPLE_FILE_PATH + filename;
            try {
                const response = await axios.get(pathFile, {
                    responseType: 'blob', // Khai báo kiểu dữ liệu là blob.
                });

                // Tạo một đường dẫn tạm thời và tạo ra một liên kết ẩn để tải xuống.
                const tempUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = tempUrl;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();

                // Giải phóng đường dẫn tạm thời sau khi tải xuống hoàn tất.
                window.URL.revokeObjectURL(tempUrl);
            } catch (error) {
                console.error('Lỗi khi tải tập tin:', error);
            }
        },
        async readFileAsBinaryString(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = (e) => reject(e);
                reader.readAsBinaryString(file);
            });
        },

        async uploadFile(file) {
            this.fileUpload = file
        },

        async onImportSubmit() {
            let temp = false
            if(this.customsSlotCheck){
                let retrunValue = await this.customsSlotCheck()
                if(!retrunValue){
                    this.$store.dispatch("alert/warning", "Có lỗi trong quá trình nhận tham số truyền vào!", { root: true });
                }
                else{
                    temp = true
                }
            }
            else {
                temp = true
            }
            if (temp && this.fileUpload[0]) {
                await this.handleImportData(this.fileUpload[0]).then(async results => {
                    if (results) {
                        this.$emit('update:dataReturn', this.listDataImport);

                        if(this.listDataImport.length === 0){
                            this.$store.dispatch("alert/warning", "Không có dữ liệu để Import!", { root: true });
                            await this.closeImportModal()
                        }
                        else{
                            $('#' + this.importModalId).modal('hide')
                            $('#' + this.importConfirmModalId).modal('show')
                        }

                    }
                    else {
                        this.$store.dispatch("alert/error", "Có lỗi trong quá trình xử lý dữ liệu Import!", { root: true });
                    }
                });
            }
            else {
                this.$store.dispatch("alert/warning", "Vui lòng chọn tập tin để Import!", { root: true });
            }
        },

        async handleImportData(file) {
            this.existsError = false;
            this.listDataImport = [];
            if (file) {
                try {
                    const result = await this.readFileAsBinaryString(file); // Read file as binary string
                    /* Parse data */
                    const wb = read(result, { type: 'binary' });
                    /* Get first worksheet */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    /* Convert array of arrays */
                    const data = utils.sheet_to_json(ws, { header: 1 });
                    const filteredData = [];

                    // Filter data for non-empty rows and add rowNumber
                    data.forEach((row, index) => {
                        if (row.some(cell => cell !== '' && cell !== null && cell !== undefined)) {
                            row.rowNumber = index + 1; // Add rowNumber to each row
                            filteredData.push(row);
                        }
                    });
                    filteredData.splice(0, this.rowBegin); // Remove header row
                    // Process each row of data
                    for (const element of filteredData) {
                        let import_DATA = {};
                        for (let config of this.columnConfig) {
                            const inputValue = element[config.columnIndex]; // Get the value from the specified column
                            import_DATA[config.name] = await this.handleTypeImport({
                                input: inputValue,
                                typeData: config.typeData,
                                required: config.required
                            });
                        }

                        // Check if there's an error in the data
                        let checkErrorRow = false
                        if (!this.existsError) {
                            for (let key in import_DATA) {
                                if (import_DATA[key].isError === true) {
                                    this.existsError = true;
                                    checkErrorRow = true
                                    break;
                                }
                            }
                        }
                        // Prepare and add data to the list
                        let insertData = {
                            rowIndex: element.rowNumber ? element.rowNumber : null,
                            checkErrorRow: checkErrorRow,
                            data: import_DATA
                        };
                        this.listDataImport.push(insertData);
                    }

                    return true; // Data processed successfully
                } catch (error) {
                    console.error("Error processing the file: ", error);
                    return false; // Error in processing the file
                }
            } else {
                console.warn("No file selected for import.");
                return false; // No file selected
            }
        },


        closeImportSubmit() {
            //Thay đổi dữ liệu showModalFlag
            this.$emit('update:showModalFlag', false);
            $('#' + this.importConfirmModalId).modal('hide')
        },

        // showImportModal() {
        //     this.$emit('update:showModalFlag', true);
        //      $('#' + this.importModalId).modal('show');
        // },
        closeImportModal() {
            //Thay đổi dữ liệu showModalFlag
            this.$emit('update:showModalFlag', false);
             $('#' + this.importModalId).modal('hide');
        },
    },
    watch: {
        showModalFlag(newVal) {
            if (newVal) {
                this.fileUpload = []
                this.tempKey = common.randomString(10)
                $('#' + this.importModalId).modal('show');
            } else {
                $('#' + this.importModalId).modal('hide');
                $('#' + this.importConfirmModalId).modal('hide');
            }
        },
    },
    async mounted() {
        this.setup()
    },
}

</script>
<style>
.custom-table-container {
    overflow-x: auto;
    /* Cho phép cuộn ngang */
    overflow-y: auto;
    /* Cuộn dọc khi cần */
    white-space: nowrap;
    /* Không xuống dòng dữ liệu */
}

.sticky-action {
    position: sticky;
    left: 0;
    background-color: #fff;
    /* Màu nền để cột cố định không bị che khuất */
    z-index: 2;
    /* Đảm bảo cột cố định ở trên cùng */
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
    /* Tạo hiệu ứng bóng cho cột cố định */
}
</style>